import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  // Three columns per portal-ux-conventions §6.2, collapsing on small screens.
  // The previous layout put bare Autocompletes in a flex row with no sizing, so
  // they shrank to their content and rendered "Gh…", "G…", "All c…" beside a
  // half-empty row — the reported defect.
  fields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  toggles: {
    marginTop: theme.spacing(1)
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  }
}))

export default useStyles
